'use client';

import { StaffRole } from '@baseball-near-you/common';
import { DropdownMenuSelect } from './DropdownMenuSelect';

export function RoleSelect(props: {
  onSelect: (val: string) => void;
  val: string;
}) {
  return (
    <DropdownMenuSelect
      onSelect={props.onSelect}
      val={props.val}
      values={Object.values(StaffRole)}
      defaultLabel="Select a role"
    />
  );
}
